import { gql } from '@apollo/client';

export const getSupplyTrailers = gql`
	query getSupplyTrailers(
		$first: Int
		$after: String
		$before: String
		$search: String
		$transporterId: Int
    $region: RegionEnum
    $active: ActiveEnum
    $status: LinkEnum
	) {
		trailers(
			first: $first
			after: $after
			before: $before
			search: $search
			transporterId: $transporterId
      region: $region
      active: $active
      status: $status
      sort: CREATED_AT_DESC
		) {
			pageInfo {
				hasNextPage
				endCursor
				hasNextPage
			}
			edges {
				node {
					cargoCapacity
					trailerReg
					transporterId
					trailerType
					id
					active
				}
			}
		}
	}
`;
